import { Col, Row, Typography } from "antd";
import React, { useEffect } from "react";

const Copyright = () => {
   useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <Row
      className="whiteBackground"
      style={{
        backgroundColor: "white",
        justifyContent: "center",
        margin: "50px 0px",
      }}
    >
      <Col xs={24} md={10}>
       <Typography.Title
          className="fontFamily1 contactbnr-content"
          style={{textAlign:'center' , fontSize: "30px", color: "#333d47", marginBottom:20 }}
        >
          {<>Copyrights</>}
        </Typography.Title>
        <div>
          <p
            className="fontFamily1"
            style={{ fontSize: "20px", marginBottom: "20px" }}
          >
            © WrightCo Academy, a division of WrightCo, all rights reserved. All
            content, materials, courses, videos, documents, graphics, and other
            resources provided on the WrightCo Academy Learning Management
            System (LMS) are the intellectual property of WrightCo and are
            protected by U.S. and international copyright laws. No part of the
            LMS content may be reproduced, distributed, transmitted, displayed,
            published, or broadcast without prior written permission from
            WrightCo. Courses and materials are intended solely for the personal
            and professional development of registered users and clients in the
            early care and education field. Unauthorized use, sharing, or
            duplication is strictly prohibited and may result in legal action.
            WrightCo®, WrightCo Academy™, and all associated logos and marks are
            trademarks of WrightCo.
          </p>
        </div>
      </Col>
    </Row>
  );
};

export default Copyright;
